import { GET_CATEGORY_FILTERS } from 'ACTIONS';
import { prepareDataPayload } from 'MODULES/api';

export const getCategoryFilters = (id = null, req) => ({
    type: GET_CATEGORY_FILTERS,
    payload: prepareDataPayload(id),
    req
});
